import styles from '@styles/SingleBoat/detail_table.module.scss';
import { Checkbox, Collapse } from 'antd';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import { FC, useState } from 'react';
import type { BoatTableMenuItem, BoatTableProps, BoatTableSubMenuItem } from './boatMenus';

type Props = BoatTableProps[number];

const isValidSubMenuItem = (item: BoatTableSubMenuItem | null | undefined): item is BoatTableSubMenuItem => {
  return !!item && typeof item.key === 'string';
};

const isValidMenuItem = (item: BoatTableMenuItem | null | undefined): item is BoatTableMenuItem => {
  return !!item && typeof item.link === 'string' && Array.isArray(item.subMenu);
};

const DetailTable: FC<Props> = ({ title, link, menu }) => {
  const [checked, setChecked] = useState(true);

  const safeMenu = menu.filter(isValidMenuItem);
  const defaultActiveKey = safeMenu.map((item) => item.link);

  const toggleEmptyFields = (e: CheckboxChangeEvent) => setChecked(e.target.checked);

  const collapseItems = safeMenu.map((item: BoatTableMenuItem) => {
    const safeSubMenu = item.subMenu.filter(isValidSubMenuItem);
    const dataSource = safeSubMenu.filter((subMenuItem) => (checked ? subMenuItem.hasValue !== false : true));

    return {
      key: item.link,
      label: <span className={styles.collapseTitle}>{item.title}</span>,
      className: styles.collapseItem,
      children: (
        <div id={item.link}>
          {/* <Table dataSource={dataSource} pagination={false} className={styles.itemTable} columns={columns} /> */}
          <table className={styles.itemTable}>
            <tbody>
              {dataSource.map((item) => (
                <tr key={item.key}>
                  <td>{item.name}</td>
                  <td>{item.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ),
    };
  });

  return (
    <div className={styles.container} id={link}>
      <div className={styles.containerTitleWrap}>
        <h3 className={styles.containerTitle}>{title}</h3>
        <Checkbox defaultChecked onChange={toggleEmptyFields}>
          Hide empty fields
        </Checkbox>
      </div>

      <Collapse defaultActiveKey={defaultActiveKey} className={styles.containerCollapse} ghost items={collapseItems} />
    </div>
  );
};

export default DetailTable;
